module.exports = __webpack_public_path__ + "img/logo-rever-text-white.e18d25a3.svg";